import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import NumberCompareTerminalMixin from './NumberCompareTerminalMixin';

const Duration = createReactClass({
  displayName: 'Duration',
  mixins: [BaseMixin, NumberCompareTerminalMixin],

  getInitialState: function() {
    return {
      minutes: this.props.node.minutesFromValue(),
      seconds: this.props.node.secondsFromValue()
    };
  },

  render: function() {
    return (
      <form className="form-inline">
        { this.renderTerminalName() }
        { this.renderRelOp() }
        { this.renderMinutesAndSeconds() }
      </form>
    );
  },

  renderMinutesAndSeconds: function() {
    return (
      <span className="combo-form-control">
        <div className="form-group" style={{ width: '150px' }}>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              value={this.state.minutes}
              onChange={this._onMinutesChange}
              onBlur={this._updateValue}
              disabled={!this.props.editable}
            />
            <div className="input-group-addon mr-small">
              <span className="input-group-text">{this.state.minutes == 1 ? "minute" : "minutes"}</span>
            </div>
          </div>
        </div>

        <div className="form-group" style={{ width: '150px' }}>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              value={this.state.seconds}
              onChange={this._onSecondsChange}
              onBlur={this._updateValue}
              disabled={!this.props.editable}
            />
            <div className="input-group-addon">
              <span className="input-group-text">{this.state.seconds == 1 ? "second" : "seconds"}</span>
            </div>
          </div>
        </div>
      </span>
    );
  },

  _onMinutesChange: function(event) {
    this.setState({
      minutes: this._sanatizeInput(event.target.value)
    });
  },

  _onSecondsChange: function(event) {
    this.setState({
      seconds: this._sanatizeInput(event.target.value)
    });
  },

  _sanatizeInput: function(input) {
    return parseInt(input) || 0;
  },

  _updateValue: function(event) {
    this.props.node.set('value', this._calculatedValue());
    this.setState({
      minutes: this.props.node.minutesFromValue(),
      seconds: this.props.node.secondsFromValue()
    });
  },

  _calculatedValue: function() {
    return (this.state.minutes * 60) + this.state.seconds;
  }
});

export default Duration;
